import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  row: {
    borderRadius: 8,
    '&:hover': {
      '& #kebab': {
        color: '#263057'
      }
    }
  },
  itemName: {
    height: 44,
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    textOverflow: 'ellipsis',
    width: '50%',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    paddingLeft: 10
  },

  itemValue: {
    height: 44,
    fontSize: 13,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'start',
    // '@media all and (max-width: 1200px)': {
    //   display: 'none'
    // },
    textOverflow: 'ellipsis',
    width: '20%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemKebab: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '10%',
    textAlign: 'start',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8
  },
  kebab: {
    color: '#B3B3B3'
  }
}))

export default useStyles
